import type { TOC } from '@ember/component/template-only'
import { get } from '@ember/object'
import { or } from 'ember-truth-helpers'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Stat {
  label: string
  value: string | number
}

interface Args {
  figures: Stat[]
  title?: string
  theme: ThemeKeys
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
}

const themes: Partial<Record<ThemeKeys, string>> = {
  blue: 'bg-oceany-blue-300',
  green: 'bg-grapey-green-300',
  orange: 'bg-juicy-orange-300',
  'dark-blue': 'bg-oceany-blue-325',
  'dark-orange': 'bg-juicy-orange-450',
  default: 'bg-black',
}

/**
 * Figure boxes component. Takes a list of stat objects and display them as a set of boxes.
 */
export const FigureBoxes: TOC<Signature> = <template>
  <div data-test-figure-boxes class="h-full" ...attributes>
    {{#if @title}}
      <div data-test-figure-boxes-title>
        <p class="mb-3 text-base font-bold">
          {{@title}}
        </p>
      </div>
    {{/if}}
    <div class="flex flex-wrap justify-between">
      {{#each @figures as |figure index|}}
        <figure-box
          data-test-figure-box={{index}}
          class="{{get themes (or @theme 'default')}}
            print:border-dusty-black-200 mr-1 mb-5 flex h-24 min-w-[200px] flex-1 items-center p-3 text-white print:border print:bg-transparent print:text-black"
        >
          <p class="label w-full text-base">
            {{figure.label}}
          </p>
          <p class="ml-2 text-3xl font-bold">
            {{figure.value}}
          </p>
        </figure-box>
      {{/each}}
    </div>
  </div>
</template>

export default FigureBoxes
